"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const GetClientDetails_1 = require("./GetClientDetails");
const GetClientList_1 = require("./GetClientList");
const GetClientAgreementList_1 = require("./GetClientAgreementList");
const GetClientOrderList_1 = require("./GetClientOrderList");
const GetClientSupplyList_1 = require("./GetClientSupplyList");
const PostClientAdd_1 = require("./PostClientAdd");
const PostClientEdit_1 = require("./PostClientEdit");
const PostClientSendNotify_1 = require("./PostClientSendNotify");
const GetClientReport_js_1 = require("./GetClientReport.js");
__exportStar(require("./GetClientDetails"), exports);
__exportStar(require("./GetClientList"), exports);
__exportStar(require("./GetClientAgreementList"), exports);
__exportStar(require("./GetClientOrderList"), exports);
__exportStar(require("./GetClientSupplyList"), exports);
__exportStar(require("./PostClientAdd"), exports);
__exportStar(require("./PostClientEdit"), exports);
__exportStar(require("./PostClientSendNotify"), exports);
__exportStar(require("./GetClientReport.js"), exports);
exports.Client = {
    GetClientDetails: GetClientDetails_1.GetClientDetails,
    GetClientList: GetClientList_1.GetClientList,
    GetClientAgreementList: GetClientAgreementList_1.GetClientAgreementList,
    GetClientOrderList: GetClientOrderList_1.GetClientOrderList,
    GetClientSupplyList: GetClientSupplyList_1.GetClientSupplyList,
    GetClientReport: GetClientReport_js_1.GetClientReport,
    PostClientAdd: PostClientAdd_1.PostClientAdd,
    PostClientEdit: PostClientEdit_1.PostClientEdit,
    PostClientSendNotify: PostClientSendNotify_1.PostClientSendNotify
};
//# sourceMappingURL=index.js.map